import { PageHeader } from "@positive/ui";
import { BusyIndicator, Button, MessageStrip } from "@ui5/webcomponents-react";
import { useTranslation } from "react-i18next";

/**
 * Shown while a screen's code or data loads: without it the previous screen stayed on display under the new menu
 * entry until the new one was ready.
 */
export function RoutePending() {
  const { t } = useTranslation("shell");
  return (
    <section className="page-section" data-testid="route-pending">
      <BusyIndicator active size="L" delay={0} text={t("route.loading")} />
    </section>
  );
}

/** Shown instead of a blank page when a screen fails to load or render. */
export function RouteError() {
  const { t } = useTranslation("shell");
  return (
    <section className="page-section page-section-status" data-testid="route-error">
      <PageHeader title={t("route.errorTitle")} />
      <MessageStrip design="Negative" hideCloseButton>
        {t("route.errorMessage")}
      </MessageStrip>
      <Button
        design="Emphasized"
        onClick={() => {
          window.location.reload();
        }}
      >
        {t("route.reload")}
      </Button>
    </section>
  );
}
